<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import { useListGridViewPreference } from '~/composables/list-grid-view-preference';
import IconGrid from '~icons/ph/grid-four-light';
import IconList from '~icons/ph/list-dashes';

const { t } = useI18n();
const { savedView, toggleView } = useListGridViewPreference();
</script>

<template>
  <button
    v-tooltip="{
      content: savedView === 'list' ? t('tooltips.grid_view') : t('tooltips.list_view'),
    }"
    class="icon-block flex h-8 cursor-pointer items-center justify-center"
    @click="toggleView"
  >
    <span class="flex w-5 items-center justify-center">
      <IconGrid
        v-if="savedView === 'list'"
        class="shrink-0 text-[18px] text-new-gray-800 dark:text-new-gray-100"
      />
      <IconList v-else class="shrink-0 text-[18px] text-new-gray-800 dark:text-new-gray-100" />
    </span>
  </button>
</template>
